var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"error-message m-0 mt-2 pl-1"},[(_vm.errorMessage)?[_c('small',[_c('b-icon',{staticClass:"mr-1",attrs:{"icon":"exclamation-circle"}}),_vm._v(_vm._s(_vm.errorMessage)+" ")],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }